import { Box, Heading } from '@opendoor/bricks/core';
import Accordion from '@opendoor/bricks/deprecated/UNSAFE_Accordion';

import styled from '@emotion/styled';

const faqItems = [
  {
    id: 'faq-why-not-agent',
    title: 'Why wouldn’t I list with my agent instead?',
    body: (
      <p>
        Listing with Opendoor provides a certain, all-cash offer that you can come back to for 60
        days while you list. When you list with Opendoor, you’ll have an entire team of people on
        your side working behind the scenes, analyzing market trends, and figuring out how to help
        you get the best offer for your home. We’ve helped customers sell in all types of different
        market conditions. Listing with Opendoor is a simple and reliable way to sell your home on
        your timeline.
      </p>
    ),
  },

  {
    id: 'faq-what-gives',
    title: 'I came to Opendoor for a cash offer because listing is a hassle. What gives?',
    body: (
      <p>
        You can still get a cash offer from Opendoor. We want to help you try and get the best
        offer, and we think we can do that by listing your home.
      </p>
    ),
  },

  {
    id: 'faq-process',
    title: 'What does this process look like?',
    body: (
      <p>
        First, you’ll tell us your home address and answer some basic questions about your home and
        selling goals. Then, we’ll provide an estimated listing range based on comparable home sales
        and a comparative market analysis, along with an all-cash offer for you to review.
      </p>
    ),
  },

  {
    id: 'faq-have-agent',
    title: 'Will I have an agent?',
    body: (
      <p>
        Yes! You’ll have a local agent who knows your neighborhood. You can rely on them and they'll
        be there for you through every step.
      </p>
    ),
  },

  {
    id: 'faq-listed',
    title: 'Will my home be listed on the MLS?',
    body: (
      <p>
        Yes, Opendoor will list your home on the MLS for 60 days. Our team will photograph and touch
        up your home to get it market-ready.
      </p>
    ),
  },

  {
    id: 'faq-price',
    title: 'Can I set the listing price?',
    body: (
      <p>
        {' '}
        You’ll work with your agent to decide what listing price makes the most sense based on your
        selling goals.
      </p>
    ),
  },

  {
    id: 'faq-catche',
    title: 'What’s the catch?',
    body: (
      <p>
        {' '}
        When you list with Opendoor, we make it our goal to get you the most money possible for your
        home. When you get more money for your home, so do we, because we make money on commission.
      </p>
    ),
  },

  {
    id: 'faq-start',
    title: 'When do the 60 days start?',
    body: (
      <p>
        {' '}
        Once your listing goes live on the MLS, you'll have 60 days to accept the locked-in,
        all-cash offer. If you think you'll need more time, just request a new Opendoor offer when
        you're ready.
      </p>
    ),
  },

  {
    id: 'faq-budget',
    title: 'What’s the $500 budget?',
    body: (
      <p>
        {' '}
        You and your agent will discuss any small improvements you could make to get your home
        market-ready. These might include deep cleaning, painting, or general tidying up. Once
        you’ve agreed on a plan, your agent will coordinate with local vendors to do the work, and
        we’ll pay up to $500.{' '}
      </p>
    ),
  },
];

const Container = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 800px;
  position: relative;
  ::after {
    content: '';
    display: block;
    clear: both;
  }

  @media (max-width: 1199px) {
    max-width: 720px;
  }

  @media (max-width: 767px) {
    max-width: 90%;
  }
`;

/* storybook-check-ignore */
const FAQs = () => {
  return (
    <Box
      as="section"
      analyticsName="cosmos-lwc-section-faqs"
      pt={[10, null, 11]}
      id="faq-container"
    >
      <Container>
        <Heading
          size="h1"
          textAlign={['center', null, 'initial']}
          mb={[7, null, null, 8]}
          fontSize={['s3', null, 's5']}
          fontWeight="bolder"
        >
          Frequently asked questions
        </Heading>
        <Box mb={[8, null, null, 9]}>
          <Accordion arrowPosition="right" items={faqItems} shouldAnimate={true} />
        </Box>
      </Container>
    </Box>
  );
};

export default FAQs;
